import { render, staticRenderFns } from "./changeEmail.vue?vue&type=template&id=489930da&scoped=true"
import script from "./changeEmail.vue?vue&type=script&lang=js"
export * from "./changeEmail.vue?vue&type=script&lang=js"
import style0 from "./changeEmail.vue?vue&type=style&index=0&id=489930da&prod&lang=scss"
import style1 from "./changeEmail.vue?vue&type=style&index=1&id=489930da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489930da",
  null
  
)

export default component.exports